import React from "react";

import { TableSkeleton } from "../Skeletons/composites";

/**
 * Table loading component — drop-in replacement for the generic Skeleton.
 *
 * @param {number} rows    — Number of skeleton rows (default: 5)
 * @param {Array}  columns — Column config array for layout-aware skeletons.
 *   Each column: { type: 'text'|'avatar-text'|'badge'|'date-range'|'block'|'text-badge', width: string }
 *   If not provided, falls back to a generic 5-column text layout.
 *
 * @example
 * // Generic fallback (backward compatible)
 * <TableLoader rows={5} />
 *
 * // Layout-aware (matches real table columns)
 * <TableLoader rows={5} columns={[
 *   { type: 'text-badge', width: '13%' },
 *   { type: 'text', width: '13%' },
 *   { type: 'text', width: '15%', lines: 2 },
 *   { type: 'date-range', width: '12%' },
 *   { type: 'text', width: '8%' },
 * ]} />
 */
const TableLoader = ({ rows = 5, columns }) => {
  // Default generic columns if none provided (backward compatible)
  const defaultColumns = [
    { type: "text", width: "15%", widths: ["70%"] },
    { type: "text", width: "15%", widths: ["80%"] },
    { type: "text", width: "20%", widths: ["60%"] },
    { type: "text", width: "15%", widths: ["75%"] },
    { type: "text", width: "12%", widths: ["50%"] },
  ];

  return (
    <TableSkeleton
      rows={rows}
      columns={columns || defaultColumns}
      showHeader={!!columns}
    />
  );
};

export default TableLoader;
